import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=7228fb33&scoped=true&"
var script = {}
import style0 from "./DialogContent.vue?vue&type=style&index=0&id=7228fb33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228fb33",
  null
  
)

export default component.exports